'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reduceDocuments;

var _document = require('../../constants/reducers/document');

function reduceDocuments(payload) {
    return {
        type: _document.REDUCE_DOCUMENTS,
        payload: payload
    };
}